export const DEFAULT_LANGUAGE = 'en';
export const LOCALES = ['en', 'fr'];
